import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Identifier, LocalStorageService } from 'app/shared/storage/services/local-storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'core-lay-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContentComponent implements OnInit, OnDestroy {
  isReloading = false;
  termsAccepted = false;

  private subscription: Subscription = new Subscription();

  constructor(
    private localStorageService: LocalStorageService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.localStorageService.getStorageItem(Identifier.TYPE_LANGUAGE).subscribe(() => {
        this.isReloading = true;
        this.ref.markForCheck();
        setTimeout(() => {
          this.isReloading = false;
          this.ref.markForCheck();
        }, 100);
      })
    );
    this.subscription.add(
      this.localStorageService
        .getStorageItem(Identifier.TYPE_COOKIE_TERMS_ACCEPTED)
        .subscribe(value => {
          this.termsAccepted = !!value;
          this.ref.markForCheck();
        })
    );
  }

  acceptCookies() {
    this.localStorageService.setStorageItem(Identifier.TYPE_COOKIE_TERMS_ACCEPTED, 'true');
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
